const utilService = {}

utilService.findObjectByKey = function(array, key, value) {
  for (var i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      return array[i]
    }
  }
  return null
}

utilService.pinSymbol = function(color) {
  // const path = 'M 0,0 -1,-2 V -43 H 1 V -2 z M 1,-40 H 30 V -20 H 1 z'
  // const path = 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z'
  const path = 'M -25, 0, a 25,25 0 1,1 50,0, a 25,25 0 1,1 -50,0'
  // const path = 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0'
  return {
    path,
    fillColor: color,
    fillOpacity: 1,
    strokeColor: '#000',
    strokeWeight: 0,
    scale: 0.5
  }
}

export default utilService
